<template>
  <v-breadcrumbs>
    <template v-for="(item, i) in items" :key="i">
      <v-breadcrumbs-item class="cursor-pointer" @click="onBreadcrumbClick(item, i)">
        {{ item.title }}
      </v-breadcrumbs-item>
      <v-breadcrumbs-divider v-if="i < items.length - 1" :divider="divider ?? '/'" />
    </template>
  </v-breadcrumbs>
</template>

<script setup lang="ts">
import { StateView } from "./mvc/state";
import type { SubdiagramBreadcrumbItem } from "./types";

const props = defineProps<{
  items: SubdiagramBreadcrumbItem[];
  divider?: string;
}>();

const emit = defineEmits<{
  (e: "select", item: SubdiagramBreadcrumbItem, index: number): void;
}>();

function onBreadcrumbClick(item: SubdiagramBreadcrumbItem, index: number) {
  emit("select", item, index);
}
</script>

<style scoped>
.breadcrumb-navigation {
  z-index: 1000;
  position: relative;
  padding: 4px 8px;
}

.v-breadcrumbs-item:not(.v-breadcrumbs-item--disabled) {
  cursor: pointer;
  text-decoration: none;
}

.v-breadcrumbs-item:not(.v-breadcrumbs-item--disabled):hover {
  text-decoration: underline;
}
</style>
